import { Layout as AntLayout, Menu, Avatar, Dropdown, Modal, Form, Input, message } from 'antd'
import {
  DashboardOutlined,
  UserOutlined,
  AppstoreOutlined,
  TeamOutlined,
  SettingOutlined,
  FileTextOutlined,
  LogoutOutlined,
} from '@ant-design/icons'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import { changePassword } from '../api/account'

const { Header, Sider, Content } = AntLayout

const Layout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { account, logout } = useAuthStore()
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)
  const [passwordForm] = Form.useForm()

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: '概览',
    },
    {
      key: '/accounts',
      icon: <UserOutlined />,
      label: '账户管理',
    },
    {
      key: '/apps',
      icon: <AppstoreOutlined />,
      label: '应用管理',
    },
    {
      key: '/users',
      icon: <TeamOutlined />,
      label: '用户管理',
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
    {
      key: '/docs',
      icon: <FileTextOutlined />,
      label: 'API 文档',
    },
  ]

  const handleMenuClick = (key: string) => {
    if (key === '/docs') {
      window.open('/docs', '_blank', 'noopener,noreferrer')
      return
    }
    navigate(key)
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const handleOpenPasswordModal = () => {
    passwordForm.resetFields()
    setIsPasswordModalOpen(true)
  }

  const handlePasswordSubmit = async (values: { oldPassword: string; newPassword: string }) => {
    try {
      await changePassword(values.oldPassword, values.newPassword)
      message.success('密码修改成功')
      setIsPasswordModalOpen(false)
    } catch (error: any) {
      message.error(error.response?.data?.error || '密码修改失败')
    }
  }

  const userMenuItems = [
    {
      key: 'change-password',
      icon: <UserOutlined />,
      label: '修改密码',
      onClick: handleOpenPasswordModal,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ]

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider theme="light" width={200}>
        <div style={{ padding: '16px', textAlign: 'center' }}>
          <h3 style={{ margin: 0, color: '#1890ff' }}>咖影AI存储平台</h3>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => handleMenuClick(key)}
        />
      </Sider>
      <AntLayout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <Avatar icon={<UserOutlined />} />
              <span>{account?.email}</span>
            </div>
          </Dropdown>
        </Header>
        <Content style={{ margin: '24px', padding: '24px', background: '#fff', borderRadius: 8 }}>
          <Outlet />
        </Content>
      </AntLayout>

      <Modal
        title="修改密码"
        open={isPasswordModalOpen}
        onOk={() => passwordForm.submit()}
        onCancel={() => setIsPasswordModalOpen(false)}
        okText="确认"
        cancelText="取消"
      >
        <Form form={passwordForm} layout="vertical" onFinish={handlePasswordSubmit}>
          <Form.Item
            name="oldPassword"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password placeholder="请输入当前密码" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 8, message: '密码至少需要8个字符' },
            ]}
            hasFeedback
          >
            <Input.Password placeholder="至少8个字符" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'))
                },
              }),
            ]}
          >
            <Input.Password placeholder="再次输入新密码" />
          </Form.Item>
        </Form>
      </Modal>
    </AntLayout>
  )
}

export default Layout
import { useState } from 'react'
